import React, { useMemo } from 'react'

import Helmet from 'react-helmet'
import useSWR from 'swr'

import { PaidSearchBrandPage as PaidSearchBrandFeaturePage } from '@features/paid-search-brand-page'
import { fromAPIRecipe, menuFetcherV3 } from '@library/menu-service'
import type { Recipe } from '@library/menu-service'
import type { Menu } from '@library/menu-service/queries/menuApiMenu/types'

import { useGetCtaProps } from 'routes/Home/Cta'

import { seo } from './seoConfig'

type PaidSearchBrandRouteProps = {
  location?: {
    query?: {
      promo_code?: string | string[]
    }
  }
}

const formatRecipes = (response?: Menu): Recipe[] => {
  if (!response || !response.recipes) {
    return []
  }

  return Object.values(response.recipes).map((recipe) => fromAPIRecipe(recipe))
}

export const PaidSearchBrandPage = ({ location }: PaidSearchBrandRouteProps) => {
  const { ctaText, ctaUri } = useGetCtaProps()

  const { data: menuResponse } = useSWR(
    {
      numPortions: 2,
    },
    menuFetcherV3,
  )

  const recipes = useMemo(() => formatRecipes(menuResponse), [menuResponse])

  return (
    <>
      <Helmet title={seo.title} meta={seo.meta} />
      <PaidSearchBrandFeaturePage
        recipes={recipes}
        signupCTA={ctaText}
        signupCTAUri={ctaUri}
        promoCode={location?.query?.promo_code}
      />
    </>
  )
}
